import { useState } from 'react';
import { useNavigate } from "react-router-dom";
import {
  Box,
  Button,
  IconButton,
  Typography,
  Menu,
  MenuItem,
  Divider,
  Grid2,
} from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import { Link } from "react-router-dom";
import { useAuth } from '../AuthContext';
import UserMenu from './UserMenu';

export default function AuthStatus() {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  let auth = useAuth();
  let navigate = useNavigate();
  const [anchorElNav, setAnchorElNav] = useState(null);
  const [anchorElUser, setAnchorElUser] = useState(null);

  const handleOpenNavMenu = (event) => {
    setAnchorElNav(event.currentTarget);
  };
  const handleOpenUserMenu = (event) => {
    setAnchorElUser(event.currentTarget);
  };

  const handleCloseNavMenu = () => {
    setAnchorElNav(null);
  };

  const handleCloseUserMenu = () => {
    setAnchorElUser(null);
  };

  if (!auth.user) {
    return (
      <>
        <Box sx={{ flexGrow: 0, display: { xs: 'flex', md: 'none' } }}>
          <IconButton
            // size="large"
            aria-label="account of current user"
            aria-controls="menu-appbar"
            aria-haspopup="true"
            onClick={handleOpenNavMenu}
            color="inherit"
          >
            <MenuIcon />
          </IconButton>
          <Menu
            id="menu-appbar"
            anchorEl={anchorElNav}
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'right',
            }}
            keepMounted
            transformOrigin={{
              vertical: 'top',
              horizontal: 'right',
            }}
            open={Boolean(anchorElNav)}
            onClose={handleCloseNavMenu}
            sx={{ display: { xs: 'block', md: 'none' } }}
          >

            <MenuItem sx={{ minWidth: 200 }} component={Link} to="/signup" onClick={handleCloseNavMenu}>
              <Typography sx={{ textAlign: 'center' }}>Sign Up</Typography>
            </MenuItem>
            <MenuItem component={Link} to="/login" onClick={handleCloseNavMenu}>
              <Typography sx={{ textAlign: 'center' }}>Log In</Typography>
            </MenuItem>
          </Menu>
        </Box>
        <Box sx={{ flexGrow: 0, display: { xs: 'none', md: 'flex' } }}>
          <Grid2 container spacing={2}>
            <Grid2>
              <Button variant="outlined" color="secondary" to="/signup" size="small" component={Link}>Create Account</Button>
            </Grid2>
            <Grid2>
              <Button variant="text" color="inherit" size="small" to="/login" component={Link}>Login</Button>
            </Grid2>
          </Grid2>
        </Box>
      </>
    )
  }

  return (<UserMenu />);
}
